import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70" }

import { useI18n } from "vue-i18n";
import ToggleItem from "./ToggleItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentToggle',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createVNode(ToggleItem, { "department-type": "damen" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("siteWide.searchApp.department.women")), 1)
      ]),
      _: 1
    }),
    _createVNode(ToggleItem, { "department-type": "herren" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("siteWide.searchApp.department.men")), 1)
      ]),
      _: 1
    }),
    _createVNode(ToggleItem, { "department-type": "kinder" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("siteWide.searchApp.department.kids")), 1)
      ]),
      _: 1
    })
  ]))
}
}

})